import { useTranslation } from '@/hooks/useTranslation';
import { OpportunityAndRisk } from '@/types/opportunityAndRisk';

const normalize = (opportunityAndRisk: OpportunityAndRisk, variant?: 'opportunity' | 'risk') => {
  const { t } = useTranslation();

  switch (opportunityAndRisk) {
    case OpportunityAndRisk.HIGH:
      return variant === 'opportunity'
        ? t('label.label.high_opportunity')
        : t('label.label.high_risk');
    case OpportunityAndRisk.MEDIUM_HIGH:
      return variant === 'opportunity'
        ? t('label.label.medium_high_opportunity')
        : t('label.label.medium_high_risk');
    case OpportunityAndRisk.MEDIUM_LOW:
      return variant === 'opportunity'
        ? t('label.label.medium_low_opportunity')
        : t('label.label.medium_low_risk');
    case OpportunityAndRisk.LOW:
      return variant === 'opportunity'
        ? t('label.label.low_opportunity')
        : t('label.label.low_risk');
    default:
      return t('label.label.all');
  }
};

export const opportunityAndRisk = {
  normalize,
};
